angular.module('surfsightApp.controllers').controller('paternaerCtrl', [
  '$scope',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdToast',
  '$interval',
  '$translate',
  '$timeout',
  '$mdSidenav',
  'organizationFactory',
  'userFactory',
  '$state',
  '$mdMedia',
  '$window',
  '$transitions',
  function (
    $scope,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdToast,
    $interval,
    $translate,
    $timeout,
    $mdSidenav,
    organizationFactory,
    userFactory,
    $state,
    $mdMedia,
    $window,
    $transitions
  ) {
    $scope.partnerData = $localStorage.partnerData
    var $translate = $filter('translate')
    $transitions.onSuccess({}, function () {
      var stateName = $state.current.name
      if (stateName == 'home.common.settings.partners.devices') {
        $scope.heading_text = 'devices'
        $scope.icon_text = 'menu'
        $scope.status = false
        $scope.select_sideStripe_menu(1)
      } else if (stateName == 'home.common.settings.partners.organizations') {
        $scope.heading_text = 'organizations'
        $scope.icon_text = 'menu'
        $scope.status = false
        $scope.select_sideStripe_menu(2)
      } else if (stateName == 'home.common.settings.partners.users') {
        $scope.heading_text = 'organizationUsers'
        $scope.icon_text = 'arrow_back'
        $scope.status = false
      }
    })
    $scope.grid_search = {}
    $scope.organizationsGrid_search = {}
    $scope.usersGrid_search = {}
    $scope.sideStripe_list = [
      {
        id: 1,
        name: 'devices',
        icon: 'time_to_leave'
      },
      {
        id: 2,
        name: 'organizations',
        icon: 'account_balance'
      },
      {
        id: 3,
        name: 'home',
        icon: 'home'
      }
    ]
    $scope.sideStripe_status = true

    $scope.toggle_sideStripe = function () {
      $scope.sideStripe_status = !$scope.sideStripe_status
    }
    $scope.openSideNav = function (sidenav_id) {
      $mdSidenav(sidenav_id).open()
    }
    $scope.closeSideNav = function (sidenav_id) {
      $mdSidenav(sidenav_id).close()
    }

    $scope.selected_sideStripe_menu = 1
    $scope.opened_sidestripe_id = 1
    $scope.sideStripe_changed = false
    $scope.select_sideStripe_menu = function (id) {
      var sideStripe = {}
      $scope.sideStripe_list.forEach(function (list) {
        if (list.id == id) {
          sideStripe = list
        }
      })
      var id = sideStripe.id
      if ($mdMedia('xs') || $mdMedia('sm')) {
        $scope.sideStripe_status = false
      }

      $scope.selected_sideStripe_menu = id
      var sideStripe_index = $scope.sideStripe_list.indexOf(sideStripe)
      if (id == 1) {
        $state.go('home.common.settings.partners.devices')
      } else if (id == 2) {
        $state.go('home.common.settings.partners.organizations')
      } else if (id == 3) {
        $state.go('home.common.settings')
      }
      $scope.sideStripe_list.forEach(function (e, i) {
        e.opened = false
        $scope.sideStripe_list[i] = e
      })
      sideStripe.opened = true
      $scope.sideStripe_list[sideStripe_index] = sideStripe
    }
    $timeout(function () {
      $scope.select_sideStripe_menu($scope.sideStripe_list[0].id)
    })
    $scope.userDetails = $localStorage.userDetails
    $scope.gridOptions = {
      data: [],
      urlSync: false
    }

    $scope.organizationGridOptions = {
      data: [],
      urlSync: false
    }
    $scope.usersGridOptions = {
      data: userFactory.list,
      urlSync: false
    }
    $scope.organizationGridOptions.data = organizationFactory.list

    var resellerID = $scope.partnerData.id
    $scope.load_devices = function () {
      var request_json = {
        method: 'GET',
        url: DEVICE_BASEURL + '/reseller/' + resellerID + '/devices'
      }
      $http(request_json).then(
        function (response) {
          if (response.data.status.code == 0) {
            $scope.gridOptions.data = response.data.devices
          } else {
            $scope.showMessageToast(response.data.status.error)
          }
        },
        function () {
          $scope.showMessageToast($translate('errorOccurred'))
        }
      )
    }
    $scope.load_devices()
    var userID = $localStorage.userDetails.id
    $scope.load_organizations = function () {
      $scope.loading = true
      var request_json = {
        method: 'GET',
        url: USER_BASEURL + '/reseller/' + resellerID + '/organizations'
      }
      $http(request_json).then(
        function (response) {
          if (response.data.status.code == 0) {
            organizationFactory.list = response.data.organizations
            $scope.organizationGridOptions.data = organizationFactory.list
          } else {
          }
          $scope.loading = false
        },
        function () {
          $scope.showMessageToast($translate('errorOccurred'))
          $scope.loading = false
        }
      )
    }
    $scope.load_organizations()
    $scope.show_addOrganization = function (ev) {
      $mdDialog
        .show({
          controller: 'OrganizationsCtrl',
          templateUrl:
            './templates/organization.add.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true
        })
        .then(
          function (response) {
            $scope.showMessageToast(response.data.status.error)
            trackItem_organization(response.data.id)
          },
          function () {}
        )
    }
    function trackItem_organization (organizationId) {
      var request_json = {
        method: 'GET',
        url: USER_BASEURL + '/organization/' + organizationId,
        data: {}
      }
      $http(request_json).then(
        function (response) {
          if (response.data.status.code == 0) {
            organizationFactory.addOrUpdateItem(response.data.organization)
            $scope.organizationGridOptions.data = organizationFactory.list
          }
        },
        function (response) {
          if (response && response.data) {
            if (response.data.statusCode == 401) {
              $state.go('home.login')
            }
          } else {
            $scope.showMessageToast($translate('errorOccurred'))
          }
        }
      )
    }
    $scope.showUsers = function (organizationId) {
      $state.go('home.common.settings.partners.users')

      $scope.organizationId = organizationId
      var request_json = {
        method: 'GET',
        url: USER_BASEURL + '/organizationUsers/' + organizationId
      }
      $http(request_json).then(
        function (response) {
          if (response.data.status.code == 0) {
            userFactory.list = response.data.users
            $scope.usersGridOptions.data = userFactory.list
          } else {
            $scope.showMessageToast(response.data.status.error)
          }
        },
        function () {
          $scope.showMessageToast($translate('errorOccurred'))
        }
      )
    }
    $scope.user_forgotPassword = function (email, ev) {
      var request_json = {
        method: 'POST',
        url: USER_BASEURL + '/forgetpassword/' + email,
        data: {}
      }
      $http(request_json).then(
        function (response) {
          if (response.data.status.code == 0) {
            if (response.data.url != '') {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .clickOutsideToClose(false)
                  .title($translate('linkForToResetPassword'))
                  .textContent(response.data.url)
                  .ariaLabel($translate('forgotPassword'))
                  .ok($translate('ok'))
                  .targetEvent(ev)
              )
            } else {
              var toast = $mdToast
                .simple()
                .textContent($translate('unableToGetPasswordResetLink'))
                .action($translate('ok'))
                .position('top')
                .actionKey('F1')
                .hideDelay(5000)

              $mdToast.show(toast)
            }
          } else {
            var toast = $mdToast
              .simple()
              .textContent(response.data.status.error)
              .action($translate('ok'))
              .position('top')
              .actionKey('F1')
              .hideDelay(5000)

            $mdToast.show(toast)
          }
        },
        function (response) {
          $scope.showMessageToast($translate('errorOccurredPleaseTryAgain'))
        }
      )
    }
    $scope.show_addUser = function (ev, organizationId) {
      $mdDialog
        .show({
          locals: {
            dataFromCaller: {
              organizationId: organizationId,
              organizations: ''
            }
          },
          controller: 'UsersCtrl',
          templateUrl: './templates/user.add.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: false,
          fullscreen: false
        })
        .then(
          function (response) {
            $scope.showMessageToast(response.data.status.error)
            trackItem_user(response.data.id)
          },
          function () {
            $scope.status = 'You cancelled the dialog.'
          }
        )
    }

    function trackItem_user (itemId) {
      var request_json = {
        method: 'GET',
        url: USER_BASEURL + '/user/' + itemId,
        data: $scope.editingOrganization
      }
      $http(request_json).then(
        function (response) {
          var index = -1
          if (response.data.status.code == 0) {
            $scope.usersGridOptions.data.forEach(function (item, i) {
              if (item.id == itemId) {
                index = i
              }
            })
            if (index >= 0) {
              $scope.usersGridOptions.data[index] = response.data.user
            } else {
              $scope.usersGridOptions.data.push(response.data.user)
              $scope.usersData = userFactory.list
              $scope.usersGridOptions.data = $scope.usersData
            }
          }
        },
        function (response) {
          if (response && response.data) {
            if (response.data.statusCode == 401) {
              $state.go('home.login')
            }
          } else {
            $scope.showMessageToast('Error occurred.')
          }
        }
      )
    }

    $scope.showMessageToast = function (message) {
      var toast = $mdToast
        .simple()
        .textContent(message)
        .action($translate('ok'))
        .position('top right')
        .actionKey('F1')
        .hideDelay(5000)
      $mdToast.show(toast).then(function (response) {
        if (response == 'ok') {
        }
      })
    }
    $scope.logout = function () {
      $state.go('logout')
    }
    $scope.cancel = function () {
      $mdDialog.cancel()
    }
    $scope.mdMedia = function (q) {
      return $mdMedia(q)
    }
  }
])
